import { AnyAction } from 'redux';
import { handleActions } from 'redux-actions';
import { merge, omit } from 'lodash';
import { Actions, updateDeviceTypeSuccess } from 'actions/deviceTypeActions';
import { DeviceType, DeviceTypeId } from 'shared/models';

export type State = Readonly<{
    loaded: boolean;
    loading: boolean;
    data: Record<DeviceTypeId, DeviceType>;
    error: string | null;
}>;

export const initialState = Object.freeze<State>({
    loaded: false,
    loading: false,
    data: {},
    error: null,
});

export const deviceTypesReducer = handleActions({
    [Actions.GET_DEVICETYPES_REQUEST]: (state: State) => {
        return { ...state, loading: true };
    },
    [Actions.GET_DEVICETYPES_SUCCESS]: (state: State, action: AnyAction) => {
        const deviceTypes: DeviceType[] = action.payload;
        return merge({}, state, {
            error: null,
            loaded: true,
            loading: false,
        }, ...deviceTypes.map(dt => ({ data: { [dt.id]: dt } })));
    },
    [Actions.GET_DEVICETYPES_FAILURE]: (state: State, action: AnyAction) => {
        return { ...state, error: action.payload.message, loading: false };
    },


    [Actions.UPDATE_DEVICETYPE_SUCCESS]: (state: State, action: ReturnType<typeof updateDeviceTypeSuccess>) => {
        const deviceType = action.payload;
        return merge({}, state, { data: { [deviceType.id]: deviceType } });
    },


    [Actions.DELETE_DEVICETYPE_SUCCESS]: (state: State, action: AnyAction) => {
        const { id } = action.meta;
        return {
            ...state,
            data: omit(state.data, id),
        };
    },
}, initialState);
